import SHeading from '@/components/atoms/SHeading'
import { listImagesUserInterFace as getListImagesUserInterFace } from '@/constants'
import Image from 'next/image'
import React from 'react'
import { useTranslation } from 'react-i18next'

const UserInterFaceDesign = () => {
  const { t } = useTranslation()
  const listImagesUserInterFace = getListImagesUserInterFace(t);

  return (
    <>
      <SHeading
        text={t('home.user_interface_design')}
        className="text-center pt-4"
      />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 ">
        {listImagesUserInterFace.map((items, index) =>
          <div key={index} className="w-full h-auto group pt-4">
            <Image
              src={items.imageSrc}
              alt={items.altText}
              width={150}
              height={0}
              className="w-auto shadow-md rounded-lg border w-full h-full transform transition-transform duration-300 hover:scale-110 hover:object-contain"
            />
            <div className="text-center text-base pt-2">
              {items.name}
            </div>
          </div>
        )}
      </div>
    </>
  )
}

export default UserInterFaceDesign